import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Grid, Box } from '@mui/material';
import DevicesIcon from '@mui/icons-material/Devices';
import AutomationIcon from '@mui/icons-material/SmartToy';
import CodeIcon from '@mui/icons-material/Code';
import StorageIcon from '@mui/icons-material/Storage';
import SensorsIcon from '@mui/icons-material/Sensors';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import {
  Section,
  SectionTitle,
  ServiceCard,
  AnimatedBox,
  GradientButton,
} from '../../components/ui';

const services = [
  {
    key: 'digitization',
    icon: <DevicesIcon />,
  },
  {
    key: 'automation',
    icon: <AutomationIcon />,
  },
  {
    key: 'development',
    icon: <CodeIcon />,
  },
  {
    key: 'enterprise',
    icon: <StorageIcon />,
  },
  {
    key: 'iot',
    icon: <SensorsIcon />,
  },
  {
    key: 'consulting',
    icon: <SupportAgentIcon />,
  },
];

export default function ServicesSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleServiceClick = () => {
    navigate('/services');
  };

  return (
    <Section variant="light">
      <Container maxWidth="lg">
        <SectionTitle
          title={t('services.title')}
          subtitle={t('services.subtitle')}
        />

        <Grid container spacing={3}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={service.key}>
              <AnimatedBox
                animation="fadeInUp"
                delay={`${index * 0.1}s`}
                sx={{ height: '100%' }}
              >
                <ServiceCard
                  icon={service.icon}
                  title={t(`services.${service.key}.title`)}
                  description={t(`services.${service.key}.description`)}
                  onClick={handleServiceClick}
                />
              </AnimatedBox>
            </Grid>
          ))}
        </Grid>

        <AnimatedBox animation="fadeInUp" delay="0.6s">
          <Box sx={{ textAlign: 'center', mt: 6 }}>
            <GradientButton component={Link} to="/services" size="large">
              {t('common.viewAll')} {t('nav.services')}
            </GradientButton>
          </Box>
        </AnimatedBox>
      </Container>
    </Section>
  );
}
